import React from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config";

export const normalizeImage = (path, baseUrl = API_BASE_URL) => {
  if (!path) {
    return "/assets/img/a1-img/avatar-placeholder.png";
  }
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  // Convert backslashes to forward slashes for URL compatibility (Windows paths)
  const cleanPath = String(path).replace(/\\/g, "/").replace(/^\/+/, "");
  const fullPath = `${baseUrl}/${cleanPath}`;
  return fullPath;
};

export const getItemKey = (item) => item._id || item.slug || item.name;

const handleImageError = (e) => {
  e.target.src = "/assets/img/a1-img/placeholder.png";
};

export const DynamicSimpleProductCard = ({ product, showTag = true }) => (
  <div className="bd-product__item-2">
    <div className="bd-product__thumb-2 w-img product-img-container">
      <Link to={`/product/${product.slug || product._id}`}>
        <img
          src={product.img}
          alt={product.name}
          className="standard-product-img"
          onError={handleImageError}
        />
      </Link>

      {showTag && product.tag ? (
        <div className="bd-product__tag">
          <span className="tag-text">{product.tag}</span>
        </div>
      ) : null}
    </div>

    <div className="bd-product__content-2">
      <span>{product.categoryName}</span>
      <h4 className="bd-product__title-2">
        <Link to={`/product/${product.slug || product._id}`}>
          {product.name}
        </Link>
      </h4>
    </div>
  </div>
);

export const DynamicDetailedProductCard = ({
  product,
  listSetter,
  onAddToCart,
  onQuantityChange,
  onWeightChange,
  buyNowLabel = "Buy Now",
  addToCartLabel = "Add To Cart",
  onlyAddToCart = false,
}) => (
  <div className="bd-product__item-3">
    <div className="bd-product__thumb-3 w-img product-img-container">
      <Link to={`/product/${product.slug || product._id}`}>
        <img
          src={product.img}
          alt={product.name}
          className="standard-product-img"
          onError={handleImageError}
        />
      </Link>
    </div>

    <div className="bd-product__content-3 d-flex flex-column">
      <div className="mb-auto">
        <span>{product.categoryName}</span>
        <h4
          className="bd-product__title-3"
          style={{ overflow: "hidden" }}
        >
          <Link to={`/product/${product.slug || product._id}`}>
            {product.name}
          </Link>
        </h4>

        <div className="bd-product__price my-3">
          <div
            className="weight-selector flex-wrap"
            style={{ display: "flex", gap: "5px" }}
          >
            {product.weights &&
              product.weights.map((wt, wtIndex) => (
                <button
                  key={wtIndex}
                  type="button"
                  className={`weight-btn ${product.net_wt === wt ? "active" : ""}`}
                  style={{
                    padding: "4px 8px",
                    fontSize: "12px",
                    border:
                      product.net_wt === wt
                        ? "1px solid #1c1d1b"
                        : "1px solid #eee",
                    background:
                      product.net_wt === wt ? "#1c1d1b" : "transparent",
                    color: product.net_wt === wt ? "#fff" : "#1c1d1b",
                  }}
                  onClick={() =>
                    onWeightChange &&
                    onWeightChange(getItemKey(product), listSetter, wt)
                  }
                >
                  {wt}
                </button>
              ))}
          </div>
        </div>

        <div className="bd-product__cart-3 d-flex justify-content-between align-items-center">
          <div className="bd-product__price-3 d-flex align-items-baseline flex-nowrap">
            <span className="small fw-bold">Rs.</span>
            <span className="fs-3 text-danger fw-bold">
              {Number(product.price).toFixed(2)}
            </span>
            {product.old_price ? (
              <del className="ms-2 text-muted small">
                {Number(product.old_price).toFixed(2)}
              </del>
            ) : null}
          </div>

          <div className="product-quantity-form">
            <form action="#" style={{ display: "flex", alignItems: "center" }}>
              <button
                type="button"
                className="cart-minus px-2"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onQuantityChange &&
                    onQuantityChange(getItemKey(product), listSetter, -1);
                }}
              >
                <i className="far fa-minus"></i>
              </button>

              <input
                className="cart-input text-center"
                type="text"
                value={product.quantity}
                readOnly
                style={{
                  width: "30px",
                  border: "none",
                  background: "transparent",
                }}
              />

              <button
                type="button"
                className="cart-plus px-2"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onQuantityChange &&
                    onQuantityChange(getItemKey(product), listSetter, 1);
                }}
              >
                <i className="far fa-plus"></i>
              </button>
            </form>
          </div>
        </div>
      </div>

      {onlyAddToCart ? (
        <div className="product-actions mt-3">
          <button
            className="bd-add__cart-btn-light w-100"
            onClick={() => onAddToCart && onAddToCart(product)}
          >
            <i className="far fa-shopping-bag"></i> {addToCartLabel}
          </button>
        </div>
      ) : (
        <div className="product-actions mt-3 d-flex gap-2">
          <button
            className="cart-icon-btn btn btn-outline-dark"
            onClick={() => onAddToCart && onAddToCart(product)}
          >
            <i className="far fa-shopping-bag"></i>
          </button>

          <button
            className="buy-now-btn btn btn-dark flex-grow-1"
            onClick={() => onAddToCart && onAddToCart(product, true)}
          >
            <i className="far fa-shopping-cart me-2"></i>
            {buyNowLabel}
          </button>
        </div>
      )}
    </div>
  </div>
);

export const DynamicComboCard = ({
  product,
  listSetter,
  onAddToCart,
  onQuantityChange,
  onWeightChange,
}) => (
  <div className="bd-product__item-3 mb-30" style={{ height: "100%" }}>
    <div className="bd-product__thumb-3 w-img product-img-container">
      <Link to={`/product/${product.slug || product._id}`}>
        <img
          src={product.img}
          alt={product.name}
          className="standard-product-img"
          onError={handleImageError}
        />
      </Link>
    </div>

    <div className="bd-product__content-3 d-flex flex-column">
      <div className="mb-auto">
        <span>{product.comboType || product.categoryName || "Combo"}</span>
        <h4
          className="bd-product__title-3"
          style={{ overflow: "hidden" }}
        >
          <Link to={`/product/${product.slug || product._id}`}>
            {product.name}
          </Link>
        </h4>

        <div className="bd-product__price my-3">
          <div
            className="weight-selector flex-wrap"
            style={{ display: "flex", gap: "5px" }}
          >
            {product.weights &&
              product.weights.map((wt, wtIndex) => (
                <button
                  key={wtIndex}
                  type="button"
                  className={`weight-btn ${product.net_wt === wt ? "active" : ""}`}
                  style={{
                    padding: "4px 8px",
                    fontSize: "12px",
                    border:
                      product.net_wt === wt
                        ? "1px solid #1c1d1b"
                        : "1px solid #eee",
                    background:
                      product.net_wt === wt ? "#1c1d1b" : "transparent",
                    color: product.net_wt === wt ? "#fff" : "#1c1d1b",
                  }}
                  onClick={() =>
                    onWeightChange &&
                    onWeightChange(getItemKey(product), listSetter, wt)
                  }
                >
                  {wt}
                </button>
              ))}
          </div>
        </div>

        <div className="bd-product__cart-3 d-flex justify-content-between align-items-center">
          <div className="bd-product__price-3 d-flex align-items-baseline flex-nowrap">
            <span className="small fw-bold">Rs.</span>
            <span className="fs-3 text-danger fw-bold">
              {Number(product.price).toFixed(2)}
            </span>
            {product.old_price ? (
              <del className="ms-2 text-muted small">
                {Number(product.old_price).toFixed(2)}
              </del>
            ) : null}
          </div>

          <div className="product-quantity-form">
            <div
              className="quantity-box"
              style={{ display: "flex", alignItems: "center" }}
            >
              <button
                type="button"
                className="cart-minus px-2"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onQuantityChange &&
                    onQuantityChange(getItemKey(product), listSetter, -1);
                }}
              >
                <i className="far fa-minus"></i>
              </button>

              <input
                className="cart-input text-center"
                type="text"
                value={product.quantity || 1}
                readOnly
                style={{
                  width: "30px",
                  border: "none",
                  background: "transparent",
                }}
              />

              <button
                type="button"
                className="cart-plus px-2"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  onQuantityChange &&
                    onQuantityChange(getItemKey(product), listSetter, 1);
                }}
              >
                <i className="far fa-plus"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="product-actions mt-3 d-flex gap-2">
        <button
          className="cart-icon-btn btn btn-outline-dark"
          onClick={() => onAddToCart && onAddToCart(product)}
        >
          <i className="far fa-shopping-bag"></i>
        </button>

        <button
          className="buy-now-btn btn btn-dark flex-grow-1"
          onClick={() => onAddToCart && onAddToCart(product, true)}
        >
          <i className="far fa-shopping-cart me-2"></i>
          Buy Now
        </button>
      </div>
    </div>
  </div>
);
